export default __webpack_public_path__ + "static/media/lian_li_205m.e67342ac.jpg";